<template>
  <div class="login-container">
    <el-card class="login-card">
      <div class="login-header">
        <h1>{{ isRegister ? '注册' : '登录' }}</h1>
        <el-button type="text" @click="toggleRegister">
          {{ isRegister ? '已有账号？登录' : '没有账号？注册' }}
        </el-button>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock">
          </el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <el-input
            v-model="loginForm.captcha"
            placeholder="请输入验证码"
            prefix-icon="el-icon-picture">
            <template slot="append">
              <img :src="captchaImage" @click="refreshCaptcha" class="captcha-image" alt="" style="width: 100px; height: 34px;"/>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="login-button"
            ref="loginButton"
            v-prevent-reclick="{ enabled: true }"
            @click="isRegister ? onRegister() : onLogin()">
            {{ isRegister ? '注册' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="login-footer">
      <p>{{ settings.platformName }} v{{ settings.version }}</p>
      <p>&copy; {{ (new Date()).getFullYear() }} <a :href="settings.telegram" target="_blank">{{ settings.author.replace(/_/g, ' ') }}</a>. All rights reserved.</p>
    </div>
  </div>
</template>

<script>
import settings from '@/config/settings';
import { registerUser, loginUser } from '@/api/user';
export default {
  name: 'Login',
  data() {
    return {
      settings: settings,
      isRegister: false,
      loginForm: {
        username: '',
        password: '',
        captcha: ''
      },
      captchaImage: '',
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    refreshCaptcha() {
      // 刷新验证码图片
      this.captchaImage = `${process.env.VUE_APP_API_BASE_URL}/captcha?t=${Date.now()}`;
    },
    toggleRegister() {
      this.isRegister = !this.isRegister;
      this.refreshCaptcha();
    },
    onRegister() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // 调用注册 API
          registerUser(this.loginForm)
            .then(response => {
              this.$message.success('注册成功');
              this.toggleRegister();
            })
            .catch(error => {
              this.$message.error(error.response.data.message);
              this.refreshCaptcha();
            })
            .finally(()=>{
              this.$refs.loginButton.$el.resetButton();
            });
        }
      });
    },
    onLogin() {
      console.log('this.$refs.loginButton:', this.$refs.loginButton);
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // 调用登录 API
          loginUser(this.loginForm)
            .then(response => {
              this.$message.success('登录成功');
              localStorage.setItem('token', response.data.token);
              this.$router.push('/home/dashboard');
            })
            .catch(error => {
              this.$message.error(error.response.data.message);
              this.refreshCaptcha();
            })
            .finally(()=>{
              this.$refs.loginButton.$el.resetButton();
            });
        }
      });
    }
  },
  mounted() {
    this.refreshCaptcha();
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #409EFF, #67C23A);
}

.login-card {
  width: 400px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 20px;
}

.login-header h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

.login-header p {
  font-size: 16px;
  color: #666;
}

.login-form {
  margin-top: 20px;
}

.login-button {
  width: 100%;
}

.captcha-image {
  margin-left: 10px;
  cursor: pointer;
  border-radius: 4px;
}

.login-footer {
  margin-top: 20px;
  text-align: center;
  color: #fff;
}

.login-footer a {
  color: #fff;
  text-decoration: underline;
}
</style>